import React, { useState } from "react";
import Button from "../button/button";

/**
 * Collapsable list component
 * @param {number} truncateAfter Truncates list after this many children
 * @returns Returns a wrapper component with a show more button that shows children
 */
const CollapsableList = ({ children, truncateAfter, wrapperClass, podcastPage = false }) =>  {
    const [ showAll, setShowAll ] = useState(false);
    
    const toggleSeeAll = () => {
        if(showAll) {
            setShowAll(false);
        }else{
            setShowAll(true);
        }
    }

    return(
        <div className={`collapsable-list-wrapper ${wrapperClass}`}>
            <div className="collapsable-list">
                { children && children.map((child, index) => {
                    return (
                        showAll || index < truncateAfter ?
                            child
                        :
                            null
                    )
                })}
            </div>
            { children && children.length > truncateAfter &&
                (showAll ? 
                    <Button
                        title={"Collpase"}
                        children={"Collapse"}
                        type={`${podcastPage ? 'see-less-podcast' : 'see-less'}`}
                        isButton={true}
                        onClick={ toggleSeeAll } 
                    /> 
                :
                    <Button
                        title={"See more"}
                        children={"See more"}
                        type={`${podcastPage ? 'see-more-podcast' : 'see-more'}`}
                        isButton={true}
                        onClick={ toggleSeeAll } 
                    />)
            }
        </div>
    )
}

export default CollapsableList;